import {AfterViewChecked, AfterViewInit, Component, OnInit, ViewChild, ElementRef, DestroyRef} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {Title} from '@angular/platform-browser';
import {DateFilterService} from '../../../../Services/dateFilter.service';
import {DataService} from '../../../../Services/data.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {StorageService} from '../../../../Services/storage.service';
import {EmailService} from '../../../../Services/email.service';
import {DataExportService} from '../../../../Services/dataExport.service';
import {AppConfigService} from '../../../../Services/app-config.service';
import {ResponseModel} from '../../../../DataModels/response-model';
import {ActivatedRoute, Router} from '@angular/router';
import {EmailModel} from '../../../../DataModels/email-model';
import {Modal} from 'bootstrap';
import {SendEmailModalComponent} from '../../../common/send-email-modal/send-email-modal.component';
import {ReportPrintService} from '../../../../Services/report-print.service';

@Component({
  selector: 'app-tax',
  templateUrl: './tax.component.html',
  styleUrls: ['./tax.component.css'],
  standalone: false
})
export class TaxComponent implements OnInit, AfterViewInit, AfterViewChecked {
  private rptName: string;
  @ViewChild('EmailContent', {static: false}) EmailContent: ElementRef;
  @ViewChild('ExcelExport', {static: false}) ExcelExport: ElementRef;

  public vm: any = {
    report: [],
    request: {
      includeUnposted: null,
      fromDate: null,
      toDate: null,
      tax_id: null,
      companyId: null,
      company_id: null,
    },
    buttonsDisabled: false,
    showFilters: false,
    company: [],
    currency: [],
    companyName: null,
    taxName: null,
    company_id: null,
    currency_id: null,
    netIncome: null,
    tax: [],
    fromDateSelect: null,
    toDateSelect: null,
    monthCount: null,
    showSpecificDates: false,
    dateError: null,
    taxError: null,
    balanceOwing: null,
    showEmail: true,
    email: {
      toemail: null,
      fromemail: this.appConfig.SysEmailAddress,
      PdfHtml: null,
      Subject: null,
    },
    subLedger: null,
    exportToExcel: true,
  };
  // Standard report header button configuration (use printReport, not direct window.print)
  buttonConfig: any = {
    reportFormat: false,
    print: false,
    printReport: true,
    email: true,
    update: true,
    exportExcel: true,
    close: true,
  };

  reportDataToSendInEmail: EmailModel = new EmailModel();
  @ViewChild(SendEmailModalComponent, {read: ElementRef}) private localSendEmailModalHost: ElementRef;

  constructor(private titleService: Title,
              public dateFilter: DateFilterService,
              public tableDataService: DataService,
              public notification: BsToastService,
              public localStorage: StorageService,
              public aEmail: EmailService,
              public excelExporter: DataExportService,
              public appConfig: AppConfigService,
              public route: ActivatedRoute,
              private router: Router,
              private reportPrint: ReportPrintService,
              private destroyRef: DestroyRef,
  ) {
  }

  close() {
    this.router.navigateByUrl('/home').then();
  }

  clear() {
    this.vm.report = [];
    this.vm.request = {
      includeUnposted: null,
      fromDate: null,
      toDate: null,
      tax_id: null,
      companyId: null,
      company_id: null,
    };
  }

  ngOnInit() {
    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((params) => {
      let hasUrlDates = false;
      if (params.toDate !== undefined) {
        this.vm.request.toDate = params.toDate;
        this.vm.showSpecificDates = true;
        hasUrlDates = true;
      }
      if (params.fromDate !== undefined) {
        this.vm.request.fromDate = params.fromDate;
        this.vm.showSpecificDates = true;
        hasUrlDates = true;
      }

      if (!this.vm.request.toDate && !this.vm.request.fromDate) {
        const storedFrom = this.localStorage.StorageGet('fromDate', '');
        const storedTo = this.localStorage.StorageGet('toDate', '');
        if (storedFrom) {
          this.vm.request.fromDate = storedFrom;
        }
        if (storedTo) {
          this.vm.request.toDate = storedTo;
        }
      }

      if (!this.vm.request.toDate && !this.vm.request.fromDate) {
        this.newDateFilter(new Date(), new Date());
        this.primeDefaultDateRange();
      }

      this.newDateFilter(this.vm.request.toDate, this.vm.request.fromDate);

      if (hasUrlDates && this.vm.request.toDate && this.vm.request.fromDate) {
        this.update();
      }
    });

    this.FilterOptionsInit();
    this.rptName = 'Tax ' + this.vm.request.fromDate + ' to ' + this.vm.request.toDate;
  }

  private primeDefaultDateRange() {
    const range = this.dateFilter.GetDefaultDateRange('span', this.vm.fromDateSelect, this.vm.toDateSelect);
    this.vm.request.toDate = range.toDate;
    this.vm.request.fromDate = range.fromDate;
  }

  ngAfterViewInit() {
    this.titleService.setTitle('Taxes');
  }

  ngAfterViewChecked() {
    // Legacy email pass-through removed in favor of unified builder
  }

  FilterOptionsInit() {
    this.tableDataService.getData('tax?state=active&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.tax = result.Data;
    });
    this.tableDataService.getData('company?state=active&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.company = result.Data;
    });
    this.tableDataService.getData('currency?state=active&pageNumber=0&pageSize=999999').subscribe((result: ResponseModel) => {
      this.vm.currency = result.Data;
    });

  }

  newDateFilter(toDate, fromDate) {
    const ret = this.dateFilter.DateFilterInit(toDate, fromDate);
    this.vm.fromDateSelect = ret.fromDateSelect;
    this.vm.toDateSelect = ret.toDateSelect;
    this.vm.monthCount = ret.monthCount;
  }

  update() {
    const tempToDate: any = new Date(this.vm.request.toDate);
    const tempFromDate: any = new Date(this.vm.request.fromDate);
    let errorDescription = '';
    if (tempFromDate > tempToDate) {
      this.vm.dateError = true;
      errorDescription += 'The To Date must be greater than the From Date. <br/>';
    }
    if (!this.vm.request.fromDate || !this.vm.request.toDate) {
      this.vm.dateError = true;
      errorDescription += 'You must select from and to dates.';
    }
    if (!this.vm.request.tax_id) {
      this.vm.taxError = true;
      errorDescription += 'Tax is required.';
    }

    if (errorDescription) {
      this.notification.showWarningToast(errorDescription);
    } else {
      this.vm.request.toDate = this.dateFilter.GetDateFormat(this.vm.request.toDate);
      this.vm.request.fromDate = this.dateFilter.GetDateFormat(this.vm.request.fromDate);
      const urlParamsJson = {
        fromDate: this.vm.request.fromDate,
        toDate: this.vm.request.toDate,
        tax_id: this.vm.request.tax_id,
        company_id: this.vm.request.company_id,
      };

      const urlParams: string = this.encodeQueryData(urlParamsJson);
      this.tableDataService.getData('TaxReport', '?' + urlParams).subscribe((result) => {
        const data = (result as any)?.Data ?? result ?? [];
        this.vm.report = Array.isArray(data) ? data : [];
        this.calcTotals();
        this.vm.buttonsDisabled = false;
        this.localStorage.StorageSet('toDate', this.vm.request.toDate);
        this.localStorage.StorageSet('fromDate', this.vm.request.fromDate);
      });
    }
  }

  exportToExcel() {
    this.excelExporter.exportToExcel(this.ExcelExport, 'Tax ' + this.vm.request.fromDate + ' to ' + this.vm.request.toDate + '.xlsx');
  }

  calcTotals() {
    // reset totals
    this.vm.netIncome = 0;
    this.vm.balanceOwing = 0;

    const list: any[] = Array.isArray(this.vm.report) ? this.vm.report : [];
    for (const rec of list) {
      if (!rec) {
        continue;
      }
      const typeId = String((rec as any)?.type_id ?? '');
      const dc = Number((rec as any)?.debit_credit ?? 0);
      if (typeId === '4' || typeId === '5' || typeId === '6') {
        this.vm.netIncome += Number(0 - dc);
      } else {
        this.vm.balanceOwing += Number(0 - dc);
      }
    }

    // Resolve tax name for header display
    this.vm.taxName = '';
    const taxList: any[] = Array.isArray(this.vm.tax) ? this.vm.tax : [];
    const match = taxList.find(t => String(t?.id) === String(this.vm.request?.tax_id));
    if (match) {
      this.vm.taxName = `${match.code ?? ''} ${match.name ?? ''}`.trim();
    }
  }

  encodeQueryData(data) {
    const ret = [];
    for (const d in data) {
      if (data[d] != null && data[d] != '') {
        ret.push(encodeURIComponent(d) + '=' + encodeURIComponent(data[d]));
      }
    }
    return ret.join('&');
  }

  setEmailData() {
    const emailDocObj = {} as EmailModel;
    const reportName = 'Tax Report';

    // printing options
    emailDocObj.print_orientation = '1'; // portrait/landscape is handled by CSS @page
    emailDocObj.convert_attachment_to = 'pdf';

    emailDocObj.fromEmail = '';
    emailDocObj.fromName = 'AcctXErp';
    emailDocObj.header_id = '' as any;
    emailDocObj.toEmail = '';
    emailDocObj.body = 'Please see the attached ' + reportName + '.<br><br><br>'
      + 'Best regards,'
      + '<br><br>'
      + 'AcctXErp'
      + '<br><br>';
    emailDocObj.Subject = 'AcctXErp ' + reportName;

    // Build HTML identical to print
    try {
      emailDocObj.pdfHtml = this.buildPrintHtml(true);
    } catch {
      // Fallback to raw export HTML if builder fails
      try {
        emailDocObj.pdfHtml = this.ExcelExport?.nativeElement?.outerHTML
          || document.getElementById('excel-export')?.outerHTML
          || '';
      } catch {
        emailDocObj.pdfHtml = '' as any;
      }
    }
    emailDocObj.activity_message = reportName;

    // deterministic file name
    const now = new Date();
    const yyyy = String(now.getFullYear());
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const dd = String(now.getDate()).padStart(2, '0');
    emailDocObj.FileName = 'Tax_Report_' + `${yyyy}${mm}${dd}` + '.pdf';

    this.reportDataToSendInEmail = emailDocObj;

    // Show the shared Send Email modal directly
    const element = document.getElementById('sendEmailModal') as HTMLElement;
    if (element) {
      const emailModal = new Modal(element);
      emailModal.show();
    }
  }

  // Print using a generated HTML document (do not use PrintService)
  printReport() {
    try {
      const html = this.buildPrintHtml();
      this.printHtmlInIframe(html);
    } catch (e) {
      console.error('Tax Report print failed', e);
      this.notification?.showWarningToast?.('Unable to print Tax Report');
    }
  }

  // Build a self-contained HTML for printing/emailing the current report
  private buildPrintHtml(forEmail: boolean = false): string {
    const rawContent = (this.ExcelExport?.nativeElement?.outerHTML || document.getElementById('excel-export')?.outerHTML || '').toString();
    const content = this.reportPrint.cleanContentHtml(rawContent);
    const from = this.vm?.request?.fromDate || '';
    const to = this.vm?.request?.toDate || '';
    const meta: { label: string; value: string }[] = [];
    if (from || to) {
      meta.push({label: 'Period', value: from && to ? `${from} to ${to}` : (from || to)});
    }
    return this.reportPrint.buildHtml({title: 'Tax Report', contentHtml: content, meta, orientation: 'landscape'});
  }

  // Utility to print HTML in a hidden iframe and clean up afterward
  private printHtmlInIframe(html: string): void {
    this.reportPrint.printInIframe(html);
  }

  private escapeHtml(text: string): string {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }
}
